import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
// import {Grid, Tooltip }from '@mui/material/Grid';
import { Grid, Tooltip } from "@mui/material";
import MDBox from 'components/MDBox';

const logos = [
  { name: 'Faherty Brand', src: '/brand_logo/Faherty-Brand.png' },
  { name: 'Peter Millar', src: '/brand_logo/Peter-Millar.png' },
  { name: 'Johnnie-O', src: '/brand_logo/johnnie-o.png' },

    // Add more logos as needed
];



const LogoSelectorDialog = ({ open, onClose, onSelect }) => {
  return (
    <Dialog open={open} onClose={onClose}       maxWidth={true} // Disable default maxWidth
            PaperProps={{ style: { width: '80%' } }}>
      <DialogTitle>Select a Logo</DialogTitle>
      <DialogContent>
      <Grid container spacing={1} padding={0.4} style={{ textAlign: "Center" }}>
          {logos.map((logo) => (
             <Tooltip title={logo.name} placement="top">
            <Grid item xs={4} key={logo.name} onClick={() => onSelect(logo.src,logo.name)}>
              {/* <MDBox
                component="img"
                src={logo.src}
                alt={logo.name}
                width="100%"
                sx={{ cursor: 'pointer', border: '1px solid gray', borderRadius: '8px' }}
              /> */}
              <img className="myimg" src={logo.src} height="85px" style={{ cursor: 'pointer' }} onClick={() => onSelect(logo.src, logo.name)} />
              <p>{logo.name}</p>
            </Grid>
            </Tooltip>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoSelectorDialog;
